export const ACCOUNTS_QUERY_KEY = 'accounts'
